import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { goodsList } from "@/api/data";
export var gameGoods = {
  namespaced: true,
  state: {
    isInit: 0,
    goodsKv: {},
    goodsQualityKv: {}
  },
  mutations: {
    setGoodsKv: function setGoodsKv(state, goodsMap) {
      state.isInit = 1;
      state.goodsKv = goodsMap;
    },
    setGoodsQualityKv: function setGoodsQualityKv(state, goodsQualityMap) {
      state.isInit = 1;
      state.goodsQualityKv = goodsQualityMap;
    }
  },
  actions: {
    getGoods: function getGoods(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, goodsMap, goodsQualityMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return goodsList();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                goodsMap = {};
                goodsQualityMap = {};
                res.data.forEach(function (val) {
                  goodsMap[val.goodsId] = val.goodsName;
                  goodsQualityMap[val.goodsId] = val.goodsQuality;
                });
                commit("setGoodsKv", goodsMap);
                commit("setGoodsQualityKv", goodsQualityMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  //派生状态
  getters: {
    goodsMap: function goodsMap(state) {
      return state.goodsKv;
    },
    goodsQualityMap: function goodsQualityMap(state) {
      return state.goodsQualityKv;
    }
  }
};